/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Walkthrough_P1_Free_TitleInputs */

const en_subscription_walkthrough_p1_free_title = /** @type {(inputs: Subscription_Walkthrough_P1_Free_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">Plus Members Gain<span style="[%2$s]"> 7 </span>Extra Focus Hours Every Week!</span>`)
};

const ar_subscription_walkthrough_p1_free_title = /** @type {(inputs: Subscription_Walkthrough_P1_Free_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">مكسب أعضاء بلس<span style="[%2$s]"> 7 </span>ساعات تركيز إضافية كل أسبوع!</span>`)
};

const de_subscription_walkthrough_p1_free_title = /** @type {(inputs: Subscription_Walkthrough_P1_Free_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">Plus-Mitglieder gewinnen<span style="[%2$s]"> 7 </span>Extra Fokus-Stunden jede Woche!</span>`)
};

const es_subscription_walkthrough_p1_free_title = /** @type {(inputs: Subscription_Walkthrough_P1_Free_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">Los miembros Plus ganan<span style="[%2$s]"> 7 </span>horas extra de concentración cada semana</span>`)
};

const fr_subscription_walkthrough_p1_free_title = /** @type {(inputs: Subscription_Walkthrough_P1_Free_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">Les membres Plus gagnent<span style="[%2$s]"> 7</span> heures de concentration supplémentaires chaque semaine!</span>`)
};

const it_subscription_walkthrough_p1_free_title = /** @type {(inputs: Subscription_Walkthrough_P1_Free_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">I membri Plus guadagnano <span style="[%2$s]">7 </span> ore di concentrazione extra ogni settimana!</span>`)
};

const ja_subscription_walkthrough_p1_free_title = /** @type {(inputs: Subscription_Walkthrough_P1_Free_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">Plusメンバーは毎週<span style="[%2$s]">7</span>時間の集中時間を獲得！</span>`)
};

const ko_subscription_walkthrough_p1_free_title = /** @type {(inputs: Subscription_Walkthrough_P1_Free_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">Plus 회원은 매주<span style="[%2$s]"> 7 </span>시간 더 집중해요!</span>`)
};

const pt_br_subscription_walkthrough_p1_free_title = /** @type {(inputs: Subscription_Walkthrough_P1_Free_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">Os membros Plus ganham <span style="[%2$s]">7</span> horas extras de foco toda semana!</span>`)
};

const ru_subscription_walkthrough_p1_free_title = /** @type {(inputs: Subscription_Walkthrough_P1_Free_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">Пользователи Plus получают <span style="[%2$s]">7 </span> дополнительных часов фокусировки каждую неделю!</span>`)
};

const th_subscription_walkthrough_p1_free_title = /** @type {(inputs: Subscription_Walkthrough_P1_Free_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">สมาชิก Plus จะได้รับ<span style="[%2$s]"> 7 </span>ชั่วโมงการโฟกัสพิเศษทุกสัปดาห์!</span>`)
};

const tr_subscription_walkthrough_p1_free_title = /** @type {(inputs: Subscription_Walkthrough_P1_Free_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">Plus Üyeleri Her Hafta Ekstra <span style="[%2$s]"> 7 </span>Odaklanma Saati Kazanıyor!</span>`)
};

const zh_cn_subscription_walkthrough_p1_free_title = /** @type {(inputs: Subscription_Walkthrough_P1_Free_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">专注时总分心？升级 Plus，每周多出<span style="[%2$s]"> 7 </span>小时专注力！</span>`)
};

const zh_tw_subscription_walkthrough_p1_free_title = /** @type {(inputs: Subscription_Walkthrough_P1_Free_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">專注時總分心？升級 Plus，每週多出<span style="[%2$s]"> 7 </span>小時專注力！</span>`)
};

/**
* | output |
* | --- |
* | "<span style=\"[%1$s]\">Plus Members Gain<span style=\"[%2$s]\"> 7 </span>Extra Focus Hours Every Week!</span>" |
*
* @param {Subscription_Walkthrough_P1_Free_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_walkthrough_p1_free_title = /** @type {((inputs?: Subscription_Walkthrough_P1_Free_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Walkthrough_P1_Free_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_walkthrough_p1_free_title(inputs)
	if (locale === "ar") return ar_subscription_walkthrough_p1_free_title(inputs)
	if (locale === "de") return de_subscription_walkthrough_p1_free_title(inputs)
	if (locale === "es") return es_subscription_walkthrough_p1_free_title(inputs)
	if (locale === "fr") return fr_subscription_walkthrough_p1_free_title(inputs)
	if (locale === "it") return it_subscription_walkthrough_p1_free_title(inputs)
	if (locale === "ja") return ja_subscription_walkthrough_p1_free_title(inputs)
	if (locale === "ko") return ko_subscription_walkthrough_p1_free_title(inputs)
	if (locale === "pt_br") return pt_br_subscription_walkthrough_p1_free_title(inputs)
	if (locale === "ru") return ru_subscription_walkthrough_p1_free_title(inputs)
	if (locale === "th") return th_subscription_walkthrough_p1_free_title(inputs)
	if (locale === "tr") return tr_subscription_walkthrough_p1_free_title(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_walkthrough_p1_free_title(inputs)
	return zh_tw_subscription_walkthrough_p1_free_title(inputs)
});